import { AppBarSection as KAppBarSection } from "@progress/kendo-react-layout";

import "./AppBar.scss";

import type { AppBarSectionProps as KAppBarSectionProps } from "@progress/kendo-react-layout";

export const AppBarSection = function render(props: KAppBarSectionProps) {
  const { className, ...otherProps } = props;
  return <KAppBarSection className={`tc-appbar-section ${className}`} {...otherProps} />;
};
